<template>
  <div class="modal-body-visualizar-pdf">
    <div
      class="modal-pdf-container animate__animated animate__bounceInDown animate__delay-0.5s"
    >
      <div class="modal-pdf-container1">
        <CloseIcon @action="closeModal" />
      </div>
      <div class="modal-pdf-container2">
        <embed
          height="100%"
          width="100%"
          :src="pdf"
          title="pdf"
          style="border-radius: 1.25rem"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalVisualizarPDF",
  components: {
    CloseIcon: () => import("@/components/icons/CloseIcon.vue"),
  },
  props: ["pdf", "screen", "size"],
  methods: {
    closeModal() {
      document.getElementsByClassName(
        "modal-body-visualizar-pdf"
      )[0].style.display = "none";
      this.$loja_gerenciar.visualizarPDF = "";
    },
  },
};
</script>

<style scoped>
.modal-body-visualizar-pdf {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 99999999999999;
  /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
  justify-content: center;
  align-items: center;
}

.modal-pdf-container {
  width: 55%;
  height: 70%;
  display: flex;
  position: relative;
  align-items: center;
  border-radius: 1.25rem;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #eaeaea;
}

.modal-pdf-container1 {
  flex: 0 0 auto;
  width: 100%;
  height: 5%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: center;
}

.modal-pdf-container2 {
  flex: 0 0 auto;
  width: 100%;
  height: 95%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0.9375rem;
  border-radius: 1.25rem;
}
</style>
